import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { ButtonPrimary } from '../../components/Button'
import FarmCards from './components/FarmCards'
// hook
import { useWalletModalToggle } from '../../state/application/hooks'
import { useActiveWeb3React } from '../../hooks'

import BodyHead from '../../components/bakery/BodyHead'
import Tabs from './components/Tabs'

import { MINTTOKEN } from '../../constants/bakery'
import { supportedNewPools } from '../../sushi/lib/constants'

const LoginBtn = styled(ButtonPrimary)`
  margin: 54px auto 0;
  width: initial;
  padding: 8px 16px;
`
const LoginBtnWrapper = styled.div`
`

export default function Bakery() {
  const { t } = useTranslation()
  const { active, account } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const [curTab, setCurTab] = useState(supportedNewPools.length > 0 ? MINTTOKEN.BAKEV2 : MINTTOKEN.BAKEV2)

  
  const toggleTab = useCallback((tab: string) => {
    setCurTab(tab)
  }, [setCurTab])

  return (
    <>
      <BodyHead hideLogo={true}></BodyHead>
      {
        !(active && account)
          ? <LoginBtnWrapper>
            <LoginBtn onClick={toggleWalletModal}>{t('Connect to a wallet')}</LoginBtn>
          </LoginBtnWrapper>
          : (
            <>
              <Tabs tokenName={curTab} toggleTab={toggleTab} />
              <FarmCards tokenName={curTab}/>
            </>
          )
      }
    </>
  )
}